import { nextApiCall } from './utils/nextApiCall';
import { BlogArticleComment, BlogArticleCommentCreation } from './blog.types';

export const addComment = async (comment: BlogArticleCommentCreation) => {
  return await nextApiCall({
    endpoint: '/api/add-comment',
    method: 'POST',
    body: comment,
    reshaper: (data: BlogArticleComment) => data,
  });
};
